import { render, staticRenderFns } from "./b23.vue?vue&type=template&id=011925f2&scoped=true"
import script from "./b23.vue?vue&type=script&lang=js"
export * from "./b23.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "011925f2",
  null
  
)

export default component.exports